<template>
  <div>
    <div v-show="!offerId && !brandId">
      <div class="row mb-md-4">
        <div class="col-12 col-md-6 flexben-page-title">
          <h1 class="m-0">{{ $t("flexben.offers_cashClub.sub_title") }}</h1>
        </div>
      </div>
      <!-- Offers table -->
      <div class="card container-bg-white mt-3">
        <div class="row p-3">
          <div class="col-6 mt-3 text-bold">
            <h3 class="mt-0 pt-1 pl-0">{{ $t("flexben.offers_cashClub.list_title") }}</h3>
          </div>
          <div class="col-6 col-md-3 mt-3">
            <label class="mb-1">
              {{ $t("flexben.offers.fields.mapped_up_mobil") }}
            </label>
            <select v-model="treeMapFilter" class="form-control">
              <option value="all">-</option>
              <option value="mapped">{{ $t("flexben.offers.fields.is_mapped") }}</option>
              <option value="unmapped">{{ $t("flexben.offers.fields.is_not_mapped") }}</option>
            </select>
          </div>
          <div class="col-12">
            <div class="table-responsive hover-table">
              <table
                class="display"
                id="offers_cash_back"
              >
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Form
      v-if="brandId"
      formAction="update"
      :options="{
        available_languages: ['en', 'ro'],
        scope_availability: []
      }"
      :itemId="brandId"
      @clearForm="_clearForm"
    />
    <content-loader :loader-visible="this.loading" :loader-error="loaderError"></content-loader>
    <cash-club-offer-details v-if="offerId" :item-id="offerId" @clearItemId="offerId = null"></cash-club-offer-details>
  </div>
</template>

<script>
import DataTable from "datatables.net-dt";
import httpFlexbenService from "@/http/http-flexben";
import CashClubOfferDetails from "@/components/flexben/offers/CashClubOfferDetails.vue";
import Form from "@/components/flexben/brands/Form.vue";

export default {
  name: "CashClubOfferList",
  components: {Form, CashClubOfferDetails},
  data: function () {
    return {
      loading: false,
      loaderError: false,
      httpService: httpFlexbenService.offersCashClub,
      offers: [],
      datatable: null,
      offerId: null,
      brandId: null,
      treeMapFilter: 'all',
    }
  },
  watch: {
    treeMapFilter() {
      if (this.datatable) {
        this.datatable.draw();
      }
    }
  },
  mounted() {
    let userRole = this.flxUserLevel().userLevel;
    if (userRole !== 'admin') {
      window.location.href = '/';
    } else {
      this._loadList();
    }
  },
  methods: {
    _clearForm() {
      this.brandId = null;
    },
    _syncItem(id) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.httpService.sync(id).then(
          () => {
            this.loading = false;
            resolve(true)
          })
          .catch((error) => {
            this.loaderError = true;
            reject(error)
          })
      })
    },

    _loadList() {
      this.loading = true;
      this.loaderError = false;

      this.httpService.list()
        .then((response) => {
          this.offers = response.data.list;
        })
        .catch(() => {
          this.loaderError = true;
        })
        .finally(() => {
          this.loading = false;

          this.$nextTick(() => {
            if (this.datatable) {
              this.datatable.destroy();
            }

            const vm = this;

            this.datatable = new DataTable('#offers_cash_back', {
              data: this.offers,
              columns: [
                {
                  title: this.$t("flexben.offers_cashClub.table.image"),
                  data: 'logo',
                  render(data) {
                    return `<img src="${data}" alt="Offer image"
                             style="width:60px;height:60px;object-fit:cover;border-radius:4px;">`;
                  },
                },
                {
                  title: this.$t("flexben.offers_cashClub.table.name"),
                  data: 'name',
                },
                {
                  title: this.$t("flexben.offers_cashClub.table.brand"),
                  data: 'brandId',
                  render(data, type, row) {
                    if (!row.brandId) return '';
                    return `
                      <button type="button"
                              class="btn action-button js-brand-update"
                              data-brand-id="${row.brandId}">
                        ${row.brandName}
                      </button>
                        `;
                  }
                },
                { title: 'Value', data: 'cashbackValue' },
                {
                  title: this.$t("flexben.offers_cashClub.table.category"),
                  data: 'category',
                  render(data, type, row) {
                    const cls = row.treeMap ? 'badge-success' : 'badge-danger';
                    const txt = row.treeMap ? vm.$t("flexben.offers.fields.is_mapped")+' UpMobil+' : vm.$t("flexben.offers.fields.is_not_mapped")+' UpMobil+' ;
                    return `<div>
                        <p>${data}</p>
                        <span class="badge ${cls}">${txt}</span>
                    </div>`
                  }
                },
                {
                  title: this.$t("flexben.offers_cashClub.table.url"),
                  data: 'url',
                  render(data) {
                    return `<a href="${data}" target="_blank" rel="noopener noreferrer">${data}</a>`;
                  },
                },
                {
                  title: this.$t("flexben.offers_cashClub.table.campaign"),
                  data: 'isSetCampaign',
                  render(data, type, row) {
                    let cls = 'badge-success';
                    let txt = 'Active Campaign';

                    if (row.isSetCampaign === null) {
                      cls = 'badge-warning';
                      txt = 'Is not set campaign';
                      return `<div>
                        <span class="badge ${cls}">${txt}</span>
                      </div>`
                    }

                    if (!row.isSetCampaign) {
                      cls = 'badge-danger';
                      txt = 'Inactive Campaign';
                      return `<div>
                        <span class="badge ${cls}">${txt}</span>
                      </div>`
                    }

                    return `<div>
                        <span class="badge ${cls}">${txt}</span>
                      </div>`
                  },
                },
                {
                  title: this.$t("flexben.offers_cashClub.table.sync"),
                  data: 'is_synced',
                  render(data) {
                    const cls = data ? 'badge-success' : 'badge-danger';
                    const txt = data ? 'Sync' : 'Un sync';
                    return `<span class="sync-badge badge ${cls}">${txt}</span>`;
                  },
                },
                {
                  data: 'id',
                  orderable: false,
                  render(data, type, row) {

                    if (row.is_synced) {
                      return `<button type="button" class="btn action-button js-see-more"
                      data-id="${row.offerId}"
                      >
                        ${vm.$t("flexben.general.btn.see_more")}
                      </button>`
                    }

                    return `
                      <button type="button"
                              class="btn action-button js-sync-offer"
                              data-id="${row.id}">
                        Run Sync
                      </button>
                        `;
                  },
                }
              ],
              createdRow: function (row, data) {
                  const btnSync = row.querySelector('.js-sync-offer');
                  const btnSeeMore = row.querySelector('.js-see-more');
                  const btnBrand = row.querySelector('.js-brand-update');

                  if (btnBrand) {
                    btnBrand.addEventListener('click', (event) => {
                      event.stopPropagation();
                      vm.brandId = data.brandId;
                    });
                  }

                  if (btnSync) {
                    btnSync.addEventListener('click', (event) => {
                      event.stopPropagation();
                      vm._syncItem(data.id).then(() => {
                          let badge = row.querySelector('.sync-badge');

                          if (badge) {
                            badge.classList.remove('badge-danger');
                            badge.classList.add('badge-success');
                            badge.innerText = 'Sync';
                          }

                          let button = row.querySelector('.js-sync-offer');

                          if (button) {
                            button.remove();
                          }

                      });
                    });
                  }

                  if (btnSeeMore) {
                    btnSeeMore.addEventListener('click', (event) => {
                      event.stopPropagation();
                      vm.offerId = data.offerId;
                    });
                  }

              },
              responsive: true,
              autoWidth: false,
            });

            const table = this.datatable;

            DataTable.ext.search.push(function (settings, data, dataIndex, rowData) {
              if (settings.nTable.id !== 'offers_cash_back') {
                return true;
              }

              const filter = vm.treeMapFilter;
              if (filter === 'all') return true;

              const row = rowData || table.row(dataIndex).data();
              const isMapped = !!row.treeMap;

              if (filter === 'mapped') {
                return isMapped;
              }

              if (filter === 'unmapped') {
                return !isMapped;
              }

              return true;
            });
          });
        });
    }
  }
}
</script>
